import dayjs from "dayjs";

export interface ReporteVentasModel {
    idlocal: number
    local: string
    indice: number
    pv: string
    caja: string
    fecha: string
    hora: string
    usuario: number
    idempleado: number
    empleado: string
    idcliente: number
    cliente: string
    descuento: number
    recargo: number
    total: number
    seña: number
    devuelto: number
    formadepago: string
    tipo: string
    numero: string
    id: number
    remito: any
    sucursalentrega?: string
    entregaen: string
    originaldevol: string
  }
  
  export const reporteVentasGridColumnDefinitions = {
    'FECHA': { Header: 'Fecha' },
    'HORA': { Header: 'Hora' },
    'EMPLEADO': { Header: 'Empleado' },
    'CLIENTE': { Header: 'Cliente' },
    'FORMADEPAGO': { Header: 'Forma De Pago' },
    'DESCUENTO': { Header: 'Descuento $', IsNumber: true },
    'RECARGO': { Header: 'Recargo $', IsNumber: true },
    'TOTAL': { Header: 'Total $', IsNumber: true },
    'NUMERO': { Header: 'Numero' },
};

/**
 * Converts a string with comma as decimal separator and period as thousands separator
 * into a valid JavaScript number.
 * Example: "70.250,10" -> 70250.10
 */
export const parseFormattedNumber = (value: string): number => {
  if (typeof value === 'string') {
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  }
  return value;
};

/**
 * Parses a date string in ISO format (e.g., "2025-01-08T00:00:00") to "DD-MM-YYYY".
 */
export const parseDateToDDMMYYYY = (value: string): string => {
  return dayjs(value).format("DD-MM-YYYY");
};

// Example usage: Ensure the "total" and "fecha" fields are parsed correctly
export const transformReporteVentasData = (data: ReporteVentasModel[]): ReporteVentasModel[] => {
  return data.map((item) => ({
    ...item,
    fecha: parseDateToDDMMYYYY(item.fecha), // Convert "fecha" to "DD-MM-YYYY"
    total: parseFormattedNumber(item.total as unknown as string), // Convert "total" to a valid number
    descuento: parseFormattedNumber(item.descuento as unknown as string), // Handle "descuento" similarly if needed
    recargo: parseFormattedNumber(item.recargo as unknown as string), // Handle "recargo" similarly if needed
  }));
};
